module.exports = __webpack_public_path__ + "img/实五角星.2079996c.png";